import { APP_CUSTOM_ERROR } from "../../constants/AppVarConstants";
import {
  COMPANY_DELETE_URL,
  COMPANY_LISTING_URL,
  UPDATE_COMPANY_STATUS_URL,
} from "../api/config";
import API_MIDDLEWARE from "../api/middleware";
import {
  SET_COMPANY_LIST,
  SET_COMPANY_LIST_PAGE,
  SET_COMPANY_LIST_ROWS_PER_PAGE,
} from "./actionTypes";
import { beginAjaxCall, endAjaxCall } from "./ajaxStatusActions";
import { setErrorMessage, setSuccessMessage } from "./appActions";

export const getCompanyList = ({ searchText, fetchSize, page, isPagination }: { searchText: string; fetchSize?: number, page?: number, isPagination?: boolean }): any => {
  return (dispatch: any, getState: any) => {
    const state = getState();
    const payload: any = {
      searchQuery: searchText || "",
    };
    if (isPagination) {
      payload.page = page || state.companyList.page;
      payload.fetchSize = fetchSize || state.companyList.rowsPerPage;
    }else{
      payload.page = 1;
      payload.fetchSize = 100000;
    }
    
    
    dispatch(beginAjaxCall());
    API_MIDDLEWARE(COMPANY_LISTING_URL, "POST", { "Content-Type": "application/json" }, payload)
      .then((res) => {
        dispatch({ type: SET_COMPANY_LIST, payload: res?.result });
        dispatch(endAjaxCall());
      })
      .catch((err) => {
        dispatch(setErrorMessage(err.errorMsg ?? APP_CUSTOM_ERROR));
        dispatch(endAjaxCall());
      });
  };
};
export const deleteCompany = (companyId: number): any => {
  return async (dispatch: any) => {
    try {
      dispatch(beginAjaxCall());

      const res = await API_MIDDLEWARE(
        COMPANY_DELETE_URL(companyId),
        "DELETE",
        { "Content-Type": "application/json" },
        { status: "deleted" }
      );

      dispatch(endAjaxCall());
      dispatch(setSuccessMessage("Company deleted successfully!"));
      return res?.result;
    } catch (err: any) {
      dispatch(setErrorMessage(err?.errorMsg ?? APP_CUSTOM_ERROR));
      dispatch(endAjaxCall());
      return false;
    }
  };
};

export const updatePerPage = (value: any): any => {
  return (dispatch: any) => {
    dispatch({ type: SET_COMPANY_LIST_ROWS_PER_PAGE, payload: value });
  };
};

export const updatePage = (value: any): any => {
  return (dispatch: any) => {
    dispatch({ type: SET_COMPANY_LIST_PAGE, payload: value });
  };
};

export const updateCompanyStatus = (companyId: number, status: string): any => {
  return async (dispatch: any) => {
    try {
      dispatch(beginAjaxCall());

      const res = await API_MIDDLEWARE(
        UPDATE_COMPANY_STATUS_URL(companyId, status),
        "PUT",
        { "Content-Type": "application/json" },
        {} // Empty body since status is passed as query parameter
      );

      dispatch(endAjaxCall());
      dispatch(setSuccessMessage(`Company ${status.toLowerCase()} successfully!`));
      return res?.result;
    } catch (err: any) {
      dispatch(setErrorMessage(err?.errorMsg ?? APP_CUSTOM_ERROR));
      dispatch(endAjaxCall());
      return false;
    }
  };
};